/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import {
  Typography, Grid,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { isString } from 'lodash';
import { getSelectedOptions } from '../../utils/Functions';
import ToolTip from './ToolTip';
import { resourceFormStyle } from '../../css/style';
import { validationErrorMessages } from '../../data/Constants';
import Dropdown from './Dropdown';

const styles = resourceFormStyle();
class FormDropDownField extends Component {
  getSelectedOption = () => {
    const { field, dropdownOptions, allowMultiple } = this.props;
    const { value } = field;
    let option = '';
    if (allowMultiple) {
      if (Array.isArray(value)) {
        return value;
      }
      if (!value) {
        return '';
      }
      if (isString(value)) {
        const arrayAsJoinedString = value;
        const splitted = arrayAsJoinedString.split(',');
        const correctOptions = dropdownOptions.filter((val) => {
          if (splitted.includes(val.value)) return true;
          return false;
        });
        return correctOptions;
      }
    } else {
      dropdownOptions.forEach((o) => {
        if (o.value === value) {
          option = o;
        }
      });
    }
    return option;
  }

  validateInput = ({ newValue }) => {
    const { field } = this.props;
    const { isRequired } = field;
    const { isRequiredError } = validationErrorMessages.field;
    let errorMsg = '';
    if (isRequired && !newValue) {
      errorMsg = isRequiredError;
    }
    return errorMsg;
  }

  onChange = (event) => {
    const selectedId = event.target.value;
    const {
      handleValueChange,
      field,
      dropdownOptions,
      allowMultiple,
    } = this.props;
    const { key } = field;
    let newValue = '';
    if (allowMultiple) {
      const selectedOptions = getSelectedOptions(event, dropdownOptions, true, key);
      newValue = selectedOptions[0] && selectedOptions.map(option => option.value).join();
    } else {
      dropdownOptions.forEach((option) => {
        if (option.id === selectedId) {
          newValue = option.value;
        }
      });
    }
    const errorMsg = this.validateInput({ newValue });
    handleValueChange({ key, newValue, errorMsg });
  }

  render() {
    const {
      field,
      apiToken,
      actions,
      dropdownOptions,
      allowMultiple,
    } = this.props;
    const {
      key,
      title,
      width,
      errorMessage,
    } = field;
    return (
      <Grid
        item
        key={field.key}
        xs={field.gridWidth ? parseInt(field.gridWidth, 10) : 'auto'}
        style={styles.gridItem}
      >
        <div>
          <div style={styles.itemTitleContainer}>
            <Typography style={styles.itemTitle}>{`${title}:`}</Typography>
            <ToolTip field={field} width={width} />
          </div>
          <React.Fragment>
            <Dropdown
              key={key}
              onChange={this.onChange}
              actions={actions}
              data={this.getSelectedOption()}
              dropdownOptions={dropdownOptions}
              style={styles.formDropdownFieldStyle}
              apiToken={apiToken}
              allowMultiple={allowMultiple}
            />
            <Typography style={styles.errorMessageStyle}>
              {errorMessage}
            </Typography>
          </React.Fragment>
        </div>
      </Grid>
    );
  }
}

FormDropDownField.propTypes = {
  field: PropTypes.objectOf(PropTypes.any).isRequired,
  handleValueChange: PropTypes.func.isRequired,
  dropdownOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
  allowMultiple: PropTypes.bool,
};

FormDropDownField.defaultProps = {
  allowMultiple: false,
};

export default FormDropDownField;
